exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".allOption[data-v-2ed9699a]{margin-bottom:10px}\n", ""]);

// exports
